import { render, staticRenderFns } from "./UnidayUniversities.vue?vue&type=template&id=2cb79c8c&scoped=true&"
import script from "./UnidayUniversities.vue?vue&type=script&lang=js&"
export * from "./UnidayUniversities.vue?vue&type=script&lang=js&"
import style0 from "./UnidayUniversities.vue?vue&type=style&index=0&id=2cb79c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb79c8c",
  null
  
)

export default component.exports